import service from "@/services/fbApiService"

export const state = () => ({
    data: {},
    newData: {},
    loading: false,
    userId: "",
    sessionId: "",
    sessionName: "",
    betType: "",
    modalOpen: false,
    ladders: [],
    error: {}
})
export const getters = {
    modalOpen: (state) => state.modalOpen
}
export const mutations = {
    set_modal(state, data) {
        state.modalOpen = data
    },
    set_data(state, data) {
        state.userId = this.$auth.user._id
        state.ladders = data
    },
    set_sessionName(state, sessionName) {
        state.sessionName = sessionName
    },
    set_betType(state, betType) {
        state.betType = betType
    },
    set_error(state, data) {
        state.error = data
    },
    set_loading(state, data) {
        state.loading = data
    }
}

export const actions = {
    async getFancyLadder({ commit }, session) {
        commit("set_data", {})
        commit("set_loading", true)
        try {
            const ladderOutput = await service.apiCallWithHeader(
                "/v2/getLadder",
                {
                    sessionId: session.session.sessionId
                }
            )
            if (
                ladderOutput &&
                ladderOutput.data &&
                ladderOutput.data.status === 200 &&
                ladderOutput.data.data &&
                ladderOutput.data.data.isBetPlaced
            ) {
                commit("set_data", ladderOutput.data.data.ladder)
            }
            commit("set_sessionName", session.session.sessionName)
            commit("set_betType", session.session.level)
            commit("set_loading", false)
        } catch (error) {
            commit("set_error", error)
            commit("set_loading", false)
        }
    }
}
